import { render, staticRenderFns } from "./EmailCampaignSelect.vue?vue&type=template&id=01a1b6fc&"
import script from "./EmailCampaignSelect.vue?vue&type=script&lang=js&"
export * from "./EmailCampaignSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports